import { d, t, fromUnixTimestamp } from '@/ui/i18n/i18n';
import { toFixed } from '@/ui/helpers';

export const useAiPhotoValidationHelpers = () => {
  const formatDate = (timestamp: number | null): string | null => {
    return timestamp ? d(new Date(fromUnixTimestamp(timestamp))) : null;
  };

  const formatConfidence = (confidence: number | null): string | null => {
    return confidence ? `${toFixed(confidence * 100)}%` : null;
  };

  const getValidationResultLabel = (result: boolean | null): string => {
    return result === true
      ? t('ai-photo-validation.positive')
      : t('ai-photo-validation.negative');
  };

  return {
    formatDate,
    formatConfidence,
    getValidationResultLabel,
  };
};
